import { createSlice } from "@reduxjs/toolkit";
import {
  AddReviewsAction,
  DeleteReviewsAction,
  GetReviewsAction,
  UpdateReviewAction,
} from "store/middlewares/reviews";

// isDeleteMeFulFilled
export const reviewsSlice = createSlice({
  name: "reviews",
  initialState: {
    reviewsLoading: true,
    reviews: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetReviewsAction.pending, (state) => {
        // state.reviewsLoading = true;
        // state.reviews = null;
        state.reviews =
          state.reviews?.data?.length > 0 ? state.reviews : null;
      })
      .addCase(GetReviewsAction.fulfilled, (state, action) => {
        state.reviewsLoading = false;
        state.reviews = action.payload.response;
      })
      .addCase(GetReviewsAction.rejected, (state) => {
        state.reviewsLoading = false;
        state.reviews = null;
      })

      // Delete Review
      .addCase(DeleteReviewsAction.fulfilled, (state, action) => {
        // state.reviewsLoading = false;
        // state.reviews = {
        //   ...state.reviews,
        //   total: state.reviews.total - 1,
        //   data: state.reviews?.data?.filter(
        //     (item) => item.id !== action.payload.id
        //   ),
        // };
        state.reviewsLoading = false;
        state.reviews = action.payload.response;
      })

      // Add Review
      .addCase(AddReviewsAction.fulfilled, (state, action) => {
        // state.reviewsLoading = false;
        // state.reviews = {
        //   ...state.reviews,
        //   total: Number(state.reviews.total) + 1,
        //   data: [action.payload.response, ...state.reviews.data],
        // };
        state.reviewsLoading = false;
        state.reviews = action.payload.response;
      })
      .addCase(UpdateReviewAction.fulfilled, (state, action)=>{
        state.reviewsLoading = false;
        state.reviews = action.payload.response;
      })
  },
});

export default reviewsSlice.reducer;
